/**
 * useAdminAuthContext - hook to access admin auth state from AdminAuthProvider.
 * Separated from AdminAuthProvider.tsx to comply with react-refresh rules.
 */

import { useContext } from 'react'
import { AdminAuthContext } from './admin-auth-context.js'
import type { UseAdminAuthReturn } from './useAdminAuth.js'

export function useAdminAuthContext(): UseAdminAuthReturn {
  const ctx = useContext(AdminAuthContext)
  if (!ctx) {
    throw new Error('useAdminAuthContext must be used within an AdminAuthProvider')
  }
  return ctx
}
